import store from '@/store';

export default (value: any): string => {
    const {countries} = store.state.countryData;

    if (countries && countries.length) {
        const found = countries.find((c) => c.code === value);

        if (found) {
            return found.name;
        }
    }

    return value;
};
